import { defineMessages } from 'react-intl';

export const messages: {
	cardCountLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	showImagesToggleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	viewCurrentFilters: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	cardCountLabel: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.card-count-label',
		defaultMessage: 'Number of cards',
		description:
			'Label for the card count input field. This field allows users to specify the number of dynamic cards to display within the Editor',
	},
	showImagesToggleLabel: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.show-images-toggle-label.non-final',
		defaultMessage: 'Show images',
		description:
			'A visible label for the toggle that shows or hides images on dynamic cards in a help hub',
	},
	viewCurrentFilters: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.view-current-filters',
		defaultMessage: 'View current filters',
		description:
			'Action button message for building dynamic cards, when clicked, shows a modal to build dynamic cards with existing filters',
	},
});
